
































import CTreeSelect from '~/components/shared/configurable/form/select/tree/CTreeSelect.vue'
import { arraysEqual } from '~/utils/array'
import { defineComponent, PropType } from '@nuxtjs/composition-api'
import { vue3Model } from '~/utils/nuxt3-migration'

export default defineComponent({
  model: vue3Model,
  components: { CTreeSelect },
  props: {
    modelValue: {
      type: Array,
      required: true,
      default() {
        return []
      }
    },
    name: {
      type: String,
      default() {
        return ''
      }
    },
    loading: { type: Boolean },
    placeholder: {
      type: String,
      default() {
        return ''
      }
    },
    categoriesCounts: {
      type: Array,
      required: false,
      default() {
        return []
      }
    },
    variant: {
      type: String as PropType<'primary' | 'blue'>,
      default: 'primary'
    },
    onlyExisting: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false },
    hideZeroCountOptions: {
      type: Boolean,
      default: false
    },
    flat: {
      type: Boolean,
      default: false
    },
    categories: {
      type: Array,
      default: null
    },
    showCounts: {
      type: Boolean,
      default: true
    },
    withoutEraser: {
      type: Boolean,
      default: false
    },
    withoutClose: {
      type: Boolean,
      default: false
    },
    header: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      options: [],
      internalLoading: false,
      values: []
    }
  },
  computed: {
    internalValue: {
      get() {
        return this.modelValue
          .map(value => parseInt(value))
          .filter(value => !Number.isNaN(value))
      },
      set(value) {
        value = JSON.parse(JSON.stringify(value))
        const internalValueCopy = JSON.parse(JSON.stringify(this.internalValue))
        if (!arraysEqual(value, internalValueCopy)) {
          this.$emit('update:modelValue', value)
        }
      }
    }
  },
  watch: {
    categoriesCounts() {
      this.getData(this.value)
    },
    categories(newVal, oldVal) {
      if (JSON.stringify(oldVal) !== JSON.stringify(newVal)) {
        this.setCategoriesData(this.categories)
      }
    }
  },
  async mounted() {
    if (!this.categories?.length) {
      await this.getData(this.value)
    } else {
      this.setCategoriesData(this.categories)
    }
  },
  methods: {
    crawl(node) {
      const categoryCount = this.categoriesCounts.find(
        categoryCount => Number(categoryCount.value) === Number(node.value)
      )
      node.count = (categoryCount && categoryCount.count) | 0
      if (node.selected || (node.children && node.children.length !== 0)) {
        this.values.push(node.value)
        node.children.forEach(n => {
          this.crawl(n)
        })
      }
    },
    treeChanged(newValue) {
      if (!arraysEqual(this.internalValue, newValue)) {
        this.$emit('update:modelValue', newValue)
        this.$emit('change', newValue)
      }
    },
    async getData(internalValue) {
      const q = []
      ;(internalValue || []).forEach(v => {
        if (v) {
          q.push('category=' + v)
        }
      })
      this.internalLoading = true
      const { data } = await this.$axios.get(
        '/api/categories/' + '?' + q.join('&')
      )
      this.setCategoriesData(data.data.categories)
      this.internalLoading = false

      // only handle the response if the value has not changed this time
    },
    setCategoriesData(categories: []) {
      this.values = []
      categories.forEach(category => {
        this.crawl(category)
      })
      this.options = categories
      this.internalValue = this.values.map(v => parseInt(v))
    }
  }
})
